import { Routes, Route, Navigate } from 'react-router-dom';
import {
  LoginPage,
  FirstAccessPage,
  ForgotPasswordPage,
  MfaSetupPage,
  ProtectedRoute,
  useSessionInit,
  useAuthStore,
} from '@ipsoftsrl/frontend-auth';

// Pages
import { DashboardPage } from './pages/DashboardPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { CensusPage } from './pages/admin/CensusPage';
import { UsersPage } from './pages/admin/UsersPage';
import { UserDetailPage } from './pages/admin/UserDetailPage';
import { PortalsPage } from './pages/admin/PortalsPage';
import { LogAttivitaPage } from './pages/admin/LogAttivitaPage';
import { LogDocumentiPage } from './pages/admin/LogDocumentiPage';
import { DocumentsPage, MandatoryDocumentsPage } from './pages/documentale';
import { IntranetAreasPage, IntranetFilesPage, IntranetAdminPage, IntranetAuditPage } from './pages/intranet';

// Layout
import { AppLayout } from './components/layout/AppLayout';
import { PageLoader } from './components/ui/LoadingSpinner';

export function App() {
  const { initializing } = useSessionInit();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (initializing) {
    return <PageLoader message="Caricamento..." />;
  }

  return (
    <Routes>
      {/* Public routes — from @ipsoftsrl/frontend-auth */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/first-access" element={<FirstAccessPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/mfa-setup" element={<MfaSetupPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/portals/documentale" element={<DocumentsPage />} />
          <Route path="/portals/documentale/mandatory" element={<MandatoryDocumentsPage />} />
          <Route path="/portals/intranet" element={<IntranetAreasPage />} />
          <Route path="/portals/intranet/areas/:areaId" element={<IntranetFilesPage />} />
          <Route path="/admin/intranet" element={<IntranetAdminPage />} />
          <Route path="/admin/intranet/audit" element={<IntranetAuditPage />} />
          <Route path="/admin/logs/activity" element={<LogAttivitaPage />} />
          <Route path="/admin/logs/documents" element={<LogDocumentiPage />} />
          <Route path="/admin/users" element={<UsersPage />} />
          <Route path="/admin/users/:id" element={<UserDetailPage />} />
          <Route path="/admin/census" element={<CensusPage />} />
          <Route path="/admin/portals" element={<PortalsPage />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
